// extracted by mini-css-extract-plugin
export default {"title":"zvZe4___ContactCard-module__title","content":"yDDUn___ContactCard-module__content","contactContainer":"hbuZn___ContactCard-module__contactContainer"};